import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex'
import api from '@home/api'
import boardApi from '@board/api'
import * as usertypes from '@account/store/types';
import {open, OpenType} from '@webparts/util/open-handler'
import ZinusBoardModal from "@webparts/views/Zinus/Modal/ZinusBoardModal.vue"
import modalHelper from '@appbase/util/modal-helper';
import * as typesAccount from '@account/store/types'

@Component({
    computed: {
        ...mapGetters({
            user: usertypes.USER,
            current: typesAccount.CURRENT
        })
    },
})
export default class NoticeTicker extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    // 
    user!: account.TUser
    items : Array<home.tickerItem> = []
    timer : any = null
    interval : number = 3000
    showIndex : number = 0
    displayCount : number = 5 
    current!: account.TCurrent

    created(){
       
        this.initTickerData()

        this.timer = setInterval(()=>{
           
            this.showIndex++
            if(this.showIndex == (this.items.length)) this.showIndex = 0

        },this.interval)
    }

    initTickerData(){
        //법인 게시판 아이디 부터 먼저 조회
        let comCode = this.user.personCode.split("_")[0]

        //2025.03.06 YSJ ADD PIC,GOC 구분 처리
        /*
        if(comCode == "C121"){ // PIC 특별처리
            //D12120으로 시작하면 중국
            //D12130으로 시작하면 인니
            //그 외 한국
            if(this.current.user.deptCode.startsWith("D12120")){

                // D041 D042 D043 D044 :  BoradId 1199 익명게시판 중국
                // D049이던 사람이 옮길경우 보드가 보일수도있음 , 
                comCode = comCode.replace("C12","C04");
                //comCode = this.current.user.deptCode.replace("D1212","C04");
            }
            else if(this.current.user.deptCode.startsWith("D12130")){
                // D051 D052 D054 : BoardId 1200 익명게시판 인도네시아
                
                comCode = comCode.replace("C12","C05");
                //comCode = this.current.user.deptCode.replace("D1213","C05");

            }
            else{
                comCode = comCode.replace("C12","C02");
            }

        }
        */
        //PIC 특별처리
        if(comCode == "C121"){
            //중국
            if(this.current.user.deptCode ==="D121403" || this.current.user.deptCode ==="D121503" || this.current.user.deptCode ==="D121603"
                ||this.current.user.deptCode.startsWith("D12120")){
                comCode = "C041";
            }
            //인도네시아
            else if(this.current.user.deptCode ==="D12140" || this.current.user.deptCode ==="D121405"
                || this.current.user.deptCode ==="D121505" || this.current.user.deptCode ==="D121605"
                || this.current.user.deptCode ==="D12160"
                ||this.current.user.deptCode.startsWith("D12130")){     
                comCode = "C051";
            }
            //한국
            else{
                comCode = "C021";
            }
        }
        //GOC 특별처리
        if(comCode == "C119"){
            //중국 
            if(this.current.user.deptCode === "D11913" ){
                comCode = "C041";
            }
            //인도네시아
            else if(this.current.user.deptCode === "D11915"){            
                comCode = "C051";
            }
            //캄보디아
            else if(this.current.user.deptCode === "D11917"){            
                comCode = "C116";
            }
            //한국
            else{
                comCode = "C021";
            }
        }

        boardApi.board.FindCoperationBoard().then(result=>{
            
            let myCoperation = result.find(co => {
                        
                //이전에는 C021 였는데 부서 데이터 변경하면서 
                //CoperationCode 가 D 로 시작함 조회값에서 D 를 C 로 변경함
                console.log('??',co.coperationCode.replace("D","C") == comCode)
                return co.coperationCode.replace("D","C") == comCode
                
            })
            if (myCoperation) {
                api.board.getTickers({
                    boardId : myCoperation.boardId,
                    displayCount : this.displayCount
                }).then(tickerResult=>{
                    this.items = tickerResult
                })
            }else{
                this.items = []
            }
        })
        
    }

     

    
    onClickedItem(boarId: number, articleId: number, title:string) {
        //alert(`board id : ${boarId}\narticle id : ${articleId}\ntype : ${this.isTeams ? 'modaltype' : 'popuptype'}`)
        if(this.isTeams){
            modalHelper.show({ component: ZinusBoardModal, force: true, value: { boardId: boarId, articleId: articleId, title:title } });
        }else{
            open(this.isTeams ? 
                OpenType.ModalRead : OpenType.PopupRead,
                {
                    boardId: boarId,
                    articleId: articleId,
                    baseUrl: (process.env.NODE_ENV === 'production' ? '/po' : '/') + "/BoardPopup/"
                });
        }
    
    }

}
